import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templateDownloadSecurityContainer = document.createElement('template');

templateDownloadSecurityContainer.innerHTML = `
  <style>${flexboxHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class='wrapper'>

    <gz-text fontweight='${FontWeights.SEMIBOLD}' fontsize='${FontSizes.HEADING_6}' lineHeight='1.2' id='downloadInstructions'></gz-text>

    <gz-text fontweight='${FontWeights.SEMIBOLD}' fontsize='${FontSizes.PARAGRAPH_11}' id='kubernetesTitle'></gz-text>
    <gz-copy-to-clipboard id='copyKubernetesDownloadSecurityContainerScript'>
      <div id='kubernetesDownloadSecurityContainerScriptInput' class='text-placeholder'></div>
    </gz-copy-to-clipboard>

    <gz-text fontweight='${FontWeights.SEMIBOLD}' fontsize='${FontSizes.PARAGRAPH_11}' id='openShiftTitle' class='hidden'></gz-text>
    <gz-copy-to-clipboard id='copyOpenShiftDownloadSecurityContainerScript' class='hidden'>
      <div id='openShiftDownloadSecurityContainerScriptInput' class='text-placeholder'></div>
    </gz-copy-to-clipboard>

    <gz-text fontweight='${FontWeights.SEMIBOLD}' fontsize='${FontSizes.PARAGRAPH_11}' id='helmTitle'></gz-text>
    <gz-copy-to-clipboard id='copyHelmDownloadSecurityContainerScript'>
     <div id='helmDownloadSecurityContainerScriptInput'  class='text-placeholder'></div>
    </gz-copy-to-clipboard>

  </div>
`;
